/** Append a cache-bust query param so replaced storage objects refresh in the browser. */
export function cacheBustUrl(
  url: string | null | undefined,
  version: string | number | null | undefined,
): string | null {
  if (!url) return null;
  if (version == null || version === '') return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${encodeURIComponent(String(version))}`;
}
